var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sv prelative fs15 cpointer ofhidden",on:{"click":function($event){return _vm.goRoute(_vm.item.id)}}},[_c('span',{staticClass:"pabsolute dt tc9"},[_vm._v(_vm._s(_vm.item.release_time))]),_vm._v("\n  "+_vm._s(_vm.item.title)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b71b01e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aedu/index/item-right.vue
// module id = null
// module chunks = 